import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {PROCEDURE_PRODUCT_LIMITS} from 'procedures/design/ProcedureDesignConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import {BLUE, BLUE_LIGHTEST, GRAY, GRAY_DARKER, hexToRgba, WHITE} from 'ui-library/Colors';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Popover from 'ui-library/floating-ui/Popover';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {ProcedureEditorContext} from '../ProcedureEditorContext';

function MethodLimitReachedTooltip(): JSX.Element {
  return (
    <div className={css(styles.addMethodPopover)}>
      Limit of {PROCEDURE_PRODUCT_LIMITS.METHODS_PER_PROCEDURE} unit operations per recipe reached
    </div>
  );
}

export function ProcedureMethodAddNodeButton(props: {
  top: number;
  left: number;
  hasValidDropZone: boolean;
  onClick: () => void;
}): JSX.Element {
  const {methodCidBeingDragged, numberOfMethods} = ProcedureEditorContext.useContext();
  const isMethodLimitReached = numberOfMethods >= PROCEDURE_PRODUCT_LIMITS.METHODS_PER_PROCEDURE;

  return (
    <Popover
      placement={FloatingPlacement.TOP}
      renderContent={() => (isMethodLimitReached ? <MethodLimitReachedTooltip /> : null)}
      isDisabled={!isMethodLimitReached}
    >
      <button
        className={css(
          styles.addButton,
          methodCidBeingDragged != null && props.hasValidDropZone && styles.enabledDropZoneShadow
        )}
        style={{top: `${props.top}px`, left: `${props.left}px`}}
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          props.onClick();
        }}
        disabled={isMethodLimitReached}
        {...getTestProps({
          component: 'ProcedureMethodAddNodeButton',
          element: 'root',
        })}
      >
        <BenchlingIcon
          className={css(
            styles.plusSign,
            methodCidBeingDragged != null && props.hasValidDropZone && styles.bluePlusSign,
            isMethodLimitReached && styles.grayPlusSign
          )}
          icon="plus"
        />
      </button>
    </Popover>
  );
}

const styles = StyleSheet.create({
  addButton: {
    background: WHITE,
    border: '1px solid',
    borderColor: GRAY_DARKER,
    cursor: 'pointer',
    borderRadius: '24px',
    display: 'inline-flex',
    alignItems: 'flex-start',
    padding: '2px',
    position: 'absolute',
    ':disabled': {
      borderColor: GRAY,
    },
  },
  enabledDropZoneShadow: {
    borderColor: BLUE,
    boxShadow: `0px 0px 0px 10px rgba(${hexToRgba(BLUE_LIGHTEST)})`,
  },
  plusSign: {
    color: GRAY_DARKER,
    width: '12px',
    height: '12px',
    marginLeft: '1px',
  },
  bluePlusSign: {
    color: BLUE,
  },
  grayPlusSign: {
    color: GRAY,
  },
  addMethodPopover: {
    lineHeight: '18px',
  },
});
